export enum EnumFilterDay {
  SevenDay = '7',
  FourteenDay = '14',
  ThirtyDay = '30',
}
